module.exports = __webpack_public_path__ + "static/103-7305e1b40860770e76d483baf4bd3d28.png";